import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { Mail, MapPin, Calendar } from "lucide-react";

export default function InvitesPanel({ onAccepted }) {
  const [invites, setInvites] = useState([]);
  const load = () => api.get("/invites/mine").then((r) => setInvites(r.data));
  useEffect(() => { load(); }, []);

  const accept = async (inv) => {
    try {
      await api.post(`/requests/${inv.request_id}/accept`);
      toast.success("You're booked! You can now message the seeker.");
      load(); onAccepted?.();
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
  };
  const decline = async (inv) => {
    await api.post(`/invites/${inv.id}/decline`);
    toast("Invitation declined");
    load();
  };

  if (invites.length === 0) return null;
  return (
    <section data-testid="invites-panel" className="mb-10">
      <div className="flex items-center gap-2 mb-3"><Mail className="w-6 h-6 text-[#D96B43]" /><h2 className="text-2xl font-display font-bold text-slate-900">You've been invited</h2></div>
      <div className="grid sm:grid-cols-2 gap-4">
        {invites.map((inv) => (
          <div key={inv.id} data-testid={`invite-${inv.id}`} className="bg-white border-2 border-[#FBEBE4] rounded-2xl p-5">
            <p className="text-sm text-slate-500">{inv.seeker_name} invited you</p>
            <Link to={`/requests/${inv.request_id}`} className="text-xl font-semibold text-slate-900 hover:text-[#D96B43]">{inv.request_title}</Link>
            <div className="mt-2 space-y-1 text-slate-600">
              <p className="flex items-center gap-2"><Calendar className="w-4 h-4 text-[#2E7D6B]" /> {inv.scheduled_at ? new Date(inv.scheduled_at).toLocaleString() : inv.scheduled_date}</p>
              <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#2E7D6B]" /> {inv.location}</p>
            </div>
            <div className="flex gap-3 mt-4">
              <button data-testid={`accept-invite-${inv.id}`} onClick={() => accept(inv)} className="flex-1 bg-[#2E7D6B] hover:bg-[#256658] text-white font-semibold min-h-[48px] rounded-xl transition-colors">Accept</button>
              <button data-testid={`decline-invite-${inv.id}`} onClick={() => decline(inv)} className="flex-1 border-2 border-[#E2D9CE] hover:border-red-400 text-slate-700 font-semibold min-h-[48px] rounded-xl transition-colors">Decline</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
